export const APOLLO_ERRORS_EVENT = 'apollo-errors-event';
export const APOLLO_ACCESS_DENIED_ERROR_EVENT = 'apollo-access-denied-error-event';
export const APOLLO_AUTH_REQUIRED_FOR_SECONDARY_OPS_EVENT = 'apollo-auth-required-for-secondary-ops-event';
export const APOLLO_NORMALIZED_ERROR_EVENT = 'apollo-normalize-error-even';
export const ignoredOperations = new Set(['GetTravellerProfiles', 'GetGdsServicesRefundInfo']);
